module.exports = __webpack_public_path__ + "static/media/locateme.ed455850.png";